<template>
  <v-dialog v-model="dialog" max-width="610px" persistent>
    <v-card class="invite-sent-modal" rounded="lg">
      <v-card-text class="modal-content">
        <!-- Title -->
        <h2 class="modal-title">{{ $t('broker.clubs.assignInviteSent.title') }}</h2>

        <!-- Description -->
        <p class="modal-description">
          {{ $t('broker.clubs.assignInviteSent.description', { name: recipientName, email: recipientEmail }) }}
        </p>

        <!-- Separator line -->
        <div class="separator-line"></div>

        <!-- Share section -->
        <div class="share-section">
          <h3 class="share-title">{{ $t('broker.clubs.assignInviteSent.shareTitle') }}</h3>

          <div class="share-row">
            <span class="share-label">{{ $t('broker.clubs.assignInviteSent.shareLabel') }}</span>
            <div class="social-icons">
              <!-- Copy link -->
              <button class="social-btn" @click="copyInviteLink" :title="linkCopied ? 'Copied!' : 'Copy link'">
                <v-icon size="16" color="#005931">fa-regular fa-link</v-icon>
              </button>
              <!-- Telegram -->
              <button class="social-btn" @click="shareToTelegram" title="Share via Telegram">
                <v-icon size="16" color="#005931">fa-brands fa-telegram</v-icon>
              </button>
              <!-- WhatsApp -->
              <button class="social-btn" @click="shareToWhatsApp" title="Share via WhatsApp">
                <v-icon size="16" color="#005931">fa-brands fa-whatsapp</v-icon>
              </button>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="modal-actions">
        <v-btn
          large
          rounded
          block
          class="close-btn"
          height="36"
          @click="handleClose"
        >
          {{ $t('broker.clubs.assignInviteSent.closeBtn') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AssignInviteSentModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    recipientName: {
      type: String,
      default: ''
    },
    recipientEmail: {
      type: String,
      default: ''
    },
    inviteLink: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      linkCopied: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.isOpen
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    shareMessage() {
      return `Join our trading community! ${this.inviteLink || window.location.origin}`
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    async copyInviteLink() {
      try {
        const link = this.inviteLink || window.location.origin
        await navigator.clipboard.writeText(link)
        this.linkCopied = true
        setTimeout(() => {
          this.linkCopied = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy link:', err)
      }
    },
    shareToTelegram() {
      const link = this.inviteLink || window.location.origin
      const url = `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent('Join our trading community!')}`
      window.open(url, '_blank')
    },
    shareToWhatsApp() {
      const link = this.inviteLink || window.location.origin
      const url = `https://wa.me/?text=${encodeURIComponent('Join our trading community! ' + link)}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.invite-sent-modal {
  background-color: #F8F8F8 !important;
  padding: 0 !important;
}

.modal-content {
  padding: 40px 40px 0 40px !important;
}

.modal-title {
  font-family: 'Aeonik', sans-serif !important;
  font-size: 30px !important;
  font-weight: 700 !important;
  line-height: 40px !important;
  color: #14161B !important;
  margin-bottom: 40px;
}

.modal-description {
  font-family: 'Avenir LT Std', 'Avenir', sans-serif;
  font-size: 16px;
  font-weight: 350;
  line-height: 1.5;
  color: #000;
  margin-bottom: 40px;
}

.separator-line {
  width: 100%;
  height: 1px;
  background-color: #ABABAB;
  margin-bottom: 40px;
}

.share-section {
  margin-bottom: 0;
}

.share-title {
  font-family: 'Aeonik', sans-serif !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  line-height: 1.5 !important;
  color: #000 !important;
  margin-bottom: 20px;
}

.share-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.share-label {
  font-family: 'Avenir LT Std', 'Avenir', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #14161B;
  letter-spacing: 0.28px;
}

.social-icons {
  display: flex;
  gap: 8px;
}

.social-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #005931;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(0, 89, 49, 0.1);
  }

  .v-icon {
    color: #005931 !important;
  }
}

.modal-actions {
  padding: 40px !important;
}

// Override broker-app global button styles
.close-btn.v-btn.v-btn {
  background-color: #EBEBEB !important;
  color: #14161B !important;
  text-transform: none !important;
  font-family: 'Aeonik', sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
  height: 36px !important;
  box-shadow: none !important;

  &:hover {
    background-color: #D9D9D9 !important;
  }
}
</style>
